import { Response } from 'miragejs';

function routing(server) {
  server.get('/companies/:companyId/reports/pending-notices/qe', (schema) => {
    const { models } = schema.qeNotices.all();
    const data = models.map((m) => m.attrs);
    const length = JSON.stringify(data).length;
    return new Response(200, { 'content-length': length }, { data });
  });

  server.delete('/companies/:companyId/cobra-qe/:employeeNumber/:cQualId', (schema, request) => {
    const { attrs: data } = schema.qeNotices.findBy({ qualid: request.params.cQualId });
    if (data) {
      return new Response(204, { 'content-length': 0 });
    }

    return new Response(404, { 'content-length': 0 });
  });
}

export default routing;
